export default "__VITE_ASSET___25MxyyB__"